import Keycloak from "keycloak-js";
import KeycloakConfig from "../config/KeycloakConfig";
import { Mutations } from "@/store/enums/StoreEnums";
import store from "@/store";
import axios from "axios";

class KeycloakService {
  private keycloak: Keycloak | null = null;

  async init() {
    this.keycloak = new Keycloak(KeycloakConfig);
    const auth = await this.keycloak.init({
      onLoad: "check-sso",
    });
    if (!auth) {
      const uriAtual = window.location.href;
      if (uriAtual != process.env?.VUE_APP_REDIRECT_LOGIN) {
        window.location.href = process.env?.VUE_APP_REDIRECT_LOGIN;
      } else {
        this.keycloak.login();
      }
    } else {
      this.setUserLogged();
    }
  }

  getInstance() {
    if (!this.keycloak) {
      throw new Error("Keycloak não inicializado");
    }
    return this.keycloak;
  }

  setUserLogged() {
    if (!this.keycloak) {
      throw new Error("Keycloak não inicializado");
    }
    store.commit(Mutations.SET_USER, this.keycloak.tokenParsed);
  }

  logout() {
    this.keycloak?.logout();
  }
}

export default new KeycloakService();
